module.exports = __webpack_public_path__ + "static/media/check.a059a729.svg";